import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import config from "../config";
import { Constant, StorageKeys } from "utils/enums";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const { api } = config;

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(Constant.access_token); // or however you store your token
    if (token) {
      config.headers["Authorization"] = `Bearer ${JSON.parse(token)}`;
    }
    const refreshToken = localStorage.getItem(Constant.refresh_token);
    if (refreshToken) {
      config.headers["refresh-token"] = `${JSON.parse(refreshToken)}`;
    }
    return config;
  },
  (error) => {
    // Do something with the request error
    return Promise.reject(error);
  }
);

// intercepting to capture errors
let isLoggingOut = false;

axios.interceptors.response.use(
  function (response) {
    const url = response?.config?.url;
  if (url && url.includes("/auth/refresh")) {
      const newAccessToken = response?.data?.access_token;
      const newRefreshToken = response?.data?.refresh_token;

      if (newAccessToken) {
        localStorage.removeItem(Constant.access_token);
        localStorage.setItem(Constant.access_token, JSON.stringify(newAccessToken));
      }

      if (newRefreshToken) {
        localStorage.removeItem(Constant.refresh_token);
        localStorage.setItem(Constant.refresh_token, JSON.stringify(newRefreshToken));
      }
    }
    return response.data ? response.data : response;
  },
  function (error) {
    try {
    const url = error?.response?.config?.url;
    const status = error?.response?.status;
    if (!url) {
        console.error("URL is undefined in the response error");
        return Promise.reject(error);
      }
      // if (url && url.includes("/auth/refresh")) {
      //   handleLogout();
      // }

        if (url?.includes("/auth/refresh") && [400, 401, 500].includes(status)) {
        handleLogout();
      }

      let message;
      
      if(error?.response?.data.message === "Invalid user credentials"){
        toast.error("Invalid username or password. Please try again.", { autoClose: 1500 });
        return
      }

      switch (status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          if (!isLoggingOut) {
            isLoggingOut = true;
            localStorage.removeItem(Constant.access_token);
            localStorage.removeItem(Constant.refresh_token);
            // toast.error("Your session is expired, please log in again", { autoClose: 1000 });
            setTimeout(() => {
              window.location.href = "/login";
              isLoggingOut = false; // reset after redirect
            }, 3000);
          }
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default:
          message = error.message || error;
      }

      return Promise.reject(message);
    } catch (err) {
      console.error("Error in axios interceptor:", err);
      return Promise.reject("An error occurred while processing the response.");
    }
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token : any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url : any, params : any) => {
    let response;
    let paramKeys : any = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any) => {
    
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url : any, data : any) => {
    return axios.patch(url, data);
  };

  put = (url : any, data : any,params : any = "") => {
    return axios.put(url, data,{params:params});
  };
  /**
   * Delete
   */
  delete = (url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return axios.delete(url, { ...config });
  };
}

  const handleLogout = () => {
      localStorage.removeItem(Constant.user);
      localStorage.removeItem(Constant.access_token)
      localStorage.removeItem(Constant.refresh_token); 
      sessionStorage.removeItem(Constant.user);
      sessionStorage.removeItem(Constant.access_token)
      sessionStorage.removeItem(Constant.refresh_token); 
      localStorage.clear();
      window.location.href = '/login';
      
    };
 
const getLoggedinUser = () => {
  const user = localStorage.getItem(Constant.user);
  const token = localStorage.getItem(Constant.access_token);
  if (!user || !token) {
    return null;
  } else {
    return {...JSON.parse(user!), token: JSON.parse(token!)};
  }
};

export { APIClient, setAuthorization, getLoggedinUser, handleLogout };